// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_80mm_40mm_1_label_layout__eQ1u3"};